import styled, { ITheme } from '../../../theme'

const StandardSelect = styled.select`
  float: right;
  height: 35px;
  line-height: 35px;
  padding-left: 10px;
  width: 50%;
  max-width: 367px;
  border: 1px solid ${(props: ITheme) => props.theme.colors.border};
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  font-weight: 500;
`

export { StandardSelect }
